<template>
  <nav aria-label="Breadcrumb" class="px-4">
    <ol class="flex items-center gap-2 lg:gap-4">
      <li
        v-for="(item, index) in items"
        :key="index"
        class="flex items-center gap-2 lg:gap-4"
      >
        <span
          v-if="index > 0"
          class="text-xs lg:text-sm text-theme-disabled"
          aria-hidden="true"
        >
          &bull;
        </span>

        <!-- Active item -->
        <span
          v-if="item.active"
          class="text-xs font-normal underline lg:text-base text-theme-primary"
          :aria-current="'page'"
        >
          {{ item.label }}
        </span>

        <!-- Clickable item -->
        <Link
          v-else-if="item.href"
          :href="item.href"
          class="text-xs text-theme-disabled lg:text-base hover:underline focus:underline"
        >
          {{ item.label }}
        </Link>

        <!-- Non-clickable item -->
        <span
          v-else
          class="text-xs font-normal lg:text-base text-theme-primary"
        >
          {{ item.label }}
        </span>
      </li>
    </ol>
  </nav>
</template>

<script>
import { Link } from '@inertiajs/vue3';

export default {
  name: 'Breadcrumbs',

  components: {
    Link,
  },

  props: {
    items: {
      type: Array,
      required: true,
      validator: (items) => {
        return items.every(item => {
          return typeof item.label === 'string';
        });
      },
    },
  },
};
</script>
